export class FormOptionsLists {
  readonly testList = ['SD1', 'SD2', 'AB1', 'OSD ZA1', 'OSD ZA2', 'OSD ZB1', 'OSD ZB2', 'OSD ZC1', 'OSD ZC2'];
  readonly typeList = ['Abkürzung', 'Adjektiv', 'Adverb', 'Artikelwort', 'Eigenname', 'Konnektor', 'Modalwort',
    'Nomen', 'Partikel', 'Präposition', 'Pronomen', 'Suffix', 'Verb', 'W-Wort', 'Zahlwort'];
  readonly typeBEList = ['ABKUERZUNG', 'ADJEKTIV', 'ADVERB', 'ARTIKELWORT', 'EIGENNAME', 'KONNEKTOR', 'MODALWORT',
    'NOMEN', 'PARTIKEL', 'PRAEPOSITION', 'PRONOMEN', 'SUFFIX', 'VERB', 'WWORT', 'ZAHLWORT'];
  readonly wordFieldList = ['Alle Einträge', 'Nur Wortfelder', 'Nur DACH- Felder', 'Ohne Felder'];
  readonly levelList = ['A0', 'A1', 'A2', 'B1', 'B2', 'C1', 'C2', 'NONE'];
  readonly levelFilterModeList = ['prod.', 'rez.', 'beide'];
  readonly searchOptionsList = ['Wort', 'Thema', 'Alles'];
  readonly countryList = ['Österreich', 'Deutschland', 'Schweiz', 'DACH'];
  readonly countryBEList = ['AUSTRIA', 'GERMANY', 'SWITZERLAND', 'DACH'];
  readonly displayedColumns = ['productive', 'name', 'country', 'category'];
  readonly displayedColumnsVocabEditing = ['productive', 'receptive', 'name', 'country', 'category', 'edit', 'details'];
  readonly displayedColumnsVocabDetails = ['productive', 'receptive', 'name', 'country', 'category', 'details'];
  readonly articleList = ['der', 'die', 'das', 'der/das', 'der/die', 'die/das'];
  readonly onlySingularList = ['Nur Singular', 'Nur Plural'];

  readonly displayedColumnsSysGrammarEditing = ['productive', 'entry', 'example', 'edit', 'details'];
  readonly displayedColumnsSysGrammarDetails = ['productive', 'entry', 'example', 'details'];
  readonly displayedColumnsFuncGrammarEditing = ['productive', 'entry', 'example', 'edit', 'details'];
  readonly displayedColumnsFuncGrammarDetails = ['productive', 'entry', 'example', 'details'];

  typeToString = new Map([
    ['ABKUERZUNG', 'Abkürzung'],
    ['ADJEKTIV', 'Adjektiv'],
    ['ADVERB', 'Adverb'],
    ['VERB', 'Verb'],
    ['ARTIKELWORT', 'Artikelwort'],
    ['EIGENNAME', 'Eigenname'],
    ['KONNEKTOR', 'Konnektor'],
    ['MODALWORT', 'Modalwort'],
    ['NOMEN', 'Nomen'],
    ['PARTIKEL', 'Partikel'],
    ['PRAEPOSITION', 'Präposition'],
    ['PRONOMEN', 'Pronomen'],
    ['SUFFIX', 'Suffix'],
    ['WWORT', 'W-Wort'],
    ['ZAHLWORT', 'Zahlwort']
  ]);

  stringToType = new Map([
    ['Abkürzung', 'ABKUERZUNG'],
    ['Adjektiv', 'ADJEKTIV'],
    ['Adverb', 'ADVERB'],
    ['Artikelwort', 'ARTIKELWORT'],
    ['Eigenname', 'EIGENNAME'],
    ['Konnektor', 'KONNEKTOR'],
    ['Modalwort', 'MODALWORT'],
    ['Nomen', 'NOMEN'],
    ['Partikel', 'PARTIKEL'],
    ['Präposition', 'PRAEPOSITION'],
    ['Pronomen', 'PRONOMEN'],
    ['Suffix', 'SUFFIX'],
    ['Verb', 'VERB'],
    ['W-Wort', 'WWORT'],
    ['Zahlwort', 'ZAHLWORT']
  ]);

  countryToString = new Map([
    ['AUSTRIA', 'A'],
    ['GERMANY', 'D'],
    ['SWITZERLAND', 'CH'],
    ['DACH', 'DACH'],
    ['AD', 'A, D'],
    ['DCH', 'D, CH'],
    ['ACH', 'A, CH']
  ]);

  stringToCountry = new Map([
    ['Österreich', 'AUSTRIA'],
    ['Deutschland', 'GERMANY'],
    ['Schweiz', 'SWITZERLAND'],
    ['DACH', 'DACH'],
    ['A-D', 'AD'],
    ['D-CH', 'DCH'],
    ['A-CH', 'ACH']
  ]);

  readonly displayedColumnsVAEditing = ['receptive', 'productive', 'entry', 'edit', 'details'];
  readonly displayedColumnsVADetails = ['receptive', 'productive', 'entry', 'details'];

  readonly displayedColumnsCdsEditing = ['receptive', 'productive', 'entry', 'edit', 'details'];
  readonly displayedColumnsCdsDetails = ['receptive', 'productive', 'entry', 'details'];

  readonly modeList = ['ORAL', 'WRITTEN'];
  readonly activityList = ['INTERACTION', 'PRODUCTION', 'RECEPTION', 'MEDIATION'];

  activityToString = new Map([
    ['INTERACTION', 'Interaktion'],
    ['PRODUCTION', 'Produktion'],
    ['RECEPTION', 'Rezeption'],
    ['MEDIATION', 'Sprachmittlung']
  ]);

  readonly displayedColumnsTextTypeEditing = ['name', 'modes', 'domains', 'interactions', 'edit', 'details'];
  readonly displayedColumnsTextTypeDetails = ['name', 'modes', 'domains', 'interactions', 'details'];
  readonly modes = ["ORAL", "WRITTEN"]
  readonly domains = ["PUBLIC", "PRIVATE", "PROFESSION", "EDUCATION"]
  readonly interactions = ["SYNCHRONOUS", "ASYNCHRONOUS"]
  readonly media = ["UNBOUND_SHEETS", "OTHER_WRITING_SURFACE", "TELEVISION_CINEMA_AND_STAGE", "RADIO_AND_AUDIO_RECORDINGS", "NEW_MEDIA", "TELEPHONE_AND_ANSWERING_MACHINE", "SPEAKER", "DIRECT_COMMUNICATION", "NEWS_AND_MAGAZINES", "BOOKS_AND_REFERENCE_WORKS"];
  readonly purpose = ["LEGAL_LIABILITY", "GENERAL_INFORMATION", "TECHNICAL_INFORMATION", "ADVERTISING", "INSTRUCTION", "TEACHING", "ENTERTAINMENT", "ART", "RELIGION",]
  readonly representations = ["CHART_OR_TABLE", "IMAGES", "MUSIC", "VERSES",]

  modesToString = new Map([
    ["ORAL", "Mündlich"],
    ["WRITTEN", "Schriftlich"]
  ])

  domainsToString = new Map([
    ["PUBLIC", "Öffentlich"],
    ["PRIVATE", "Privat"],
    ["PROFESSION", "Beruf"],
    ["EDUCATION", "Bildung"]
  ])

  interactionsToString = new Map([
    ["SYNCHRONOUS", "zeitgleich"],
    ["ASYNCHRONOUS", "zeitversetzt"]
  ])

  mediaToString = new Map([
    ["UNBOUND_SHEETS", "Ungebundene Blätter"],
    ["OTHER_WRITING_SURFACE", "andere Schriftträger (z.B. Metall, Holz, OHP-Folien, Glas)"],
    ["TELEVISION_CINEMA_AND_STAGE", "Fernseher, Kino und Bühne"],
    ["RADIO_AND_AUDIO_RECORDINGS", "Radio und Audioaufnahmen"],
    ["NEW_MEDIA", "Neue Medien"],
    ["TELEPHONE_AND_ANSWERING_MACHINE", "Telefon/Anrufbeantworter"],
    ["SPEAKER", "Lautsprecher"],
    ["DIRECT_COMMUNICATION", "direkt (kein zusätzliches Übertragungsmedium)"],
    ["NEWS_AND_MAGAZINES", "Zeitung und Zeitschrift"],
    ["BOOKS_AND_REFERENCE_WORKS", "Buch (und Nachschlagewerk)"]
  ])

  purposesToString = new Map([
    ["LEGAL_LIABILITY", "amtliche/juristische Verbindlichkeit"],
    ["GENERAL_INFORMATION", "Allgemeine Information"],
    ["TECHNICAL_INFORMATION", "Fachliche Information"],
    ["ADVERTISING", "Werbung"],
    ["INSTRUCTION", "Anweisung - Instruktion"],
    ["TEACHING", "Unterricht"],
    ["ENTERTAINMENT", "Unterhaltung"],
    ["ART", "Kunst"],
    ["RELIGION", "Religion"]
  ])

  representationsToString = new Map([
    ["CHART_OR_TABLE", "Grafik oder Tabelle"],
    ["IMAGES", "mit Bildern"],
    ["MUSIC", "mit Musik"],
    ["VERSES", "in Versen"]
  ])
}
